import React from "react";
import ModalBody from "reactstrap/lib/ModalBody";
import Modal from "reactstrap/lib/Modal";
import CloseIcon from "@material-ui/icons/Close";
import ReconciliationService from "../../../Services/ReconciliationService";
import InvoiceService from "../../../Services/InvoiceService";
import { CircularProgress } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { css, cx } from "emotion";
import moment from "moment-timezone";
import { formatCurrency } from "../../../components/Utils/Currency";
import { handleError } from "../../../components/Utils/Utils";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";

const ModalUpdate = (props) => {
  const { modal, toggle, data, onUpdated } = props;
  const [loading, setLoading] = React.useState(false);
  const [note, setNote] = React.useState("");
  const radioTypeRef = React.useRef();

  const handleOnChange = (e) => {
    setNote(e.target.value);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const type = data.type;
    const id = data.reference;
    const date = new Date().toISOString();

    const params = [
      {
        op: "replace",
        path: "/settled_manual",
        value: true,
      },
      {
        op: "replace",
        path: "/settled_manual_at",
        value: date,
      },
      {
        op: "replace",
        path: "/settled_manual_note",
        value: note,
      },
    ];

    switch (type) {
      case "reconciliation_transaction":
        ReconciliationService.patchReconciliationTransactionSettled(id, params)
          .then((response) => {
            console.log(response);
            setLoading(false);
            notifUtils("Successfuly manual flaging reconciliation", "success");
            onUpdated();
          })
          .catch((error) => {
            setLoading(false);
            handleError(error);
          });
        break;

      default:
        InvoiceService.patchInvoiceSettled(id, params)
          .then((response) => {
            console.log(response);
            setLoading(false);
            notifUtils("Successfuly manual flaging reconciliation", "success");
            onUpdated();
          })
          .catch((error) => {
            setLoading(false);
            handleError(error);
          });
        break;
    }
  };

  React.useEffect(() => {
    if (modal === false) {
      setNote("")
    }
  }, [modal]);

  return (
    <Modal isOpen={modal} toggle={toggle} centered={true} size="md">
      <ModalBody>
        <div className="d-flex justify-content-between align-items-start">
          <div
            className={cx(
              css`
                width: 90%;
              `
            )}
          >
            <div>
              <div className="form-group">
                <label className="control-label font-bold font-12 text-primary">
                  Tanggal Transaksi
                </label>
                <p className="font-12 text-primary border-bottom-1-secondary pb-2 pt-1">
                  {moment(data?.trx_date).format("DD/MM/YYYY")}
                </p>
              </div>
              <div className="form-group">
                <label className="control-label font-bold font-12 text-primary">
                  Nomor Transaksi
                </label>
                <p className="font-12 text-primary border-bottom-1-secondary pb-2 pt-1">
                  {data?.reference || "-"}
                </p>
              </div>
              <div className="form-group">
                <label className="control-label font-bold font-12 text-primary">
                  Jumlah
                </label>
                <p className="font-12 text-primary border-bottom-1-secondary pb-2 pt-1">
                  {formatCurrency(
                    process.env.REACT_APP_CURRENCY_CODE,
                    (data?.amount || 0).toString()
                  )}
                </p>
              </div>
            </div>
          </div>
          <button type="button" className="btn p-0" onClick={toggle}>
            <CloseIcon />
          </button>
        </div>
        <div className="d-block w-100">
          <div>
            <div className="form-group">
              <label className="control-label font-bold font-12 text-primary">
                Note (optional)
              </label>
              <textarea
                className={cx(
                  css`
                    background-color: #eeeeee !important;
                    min-height: 100px;
                    ::placeholder {
                      color: #757575;
                    }
                  `,
                  "form-control border-0 rounded font-12"
                )}
                placeholder="Nomor transaksi terjadi kesalahan, etc"
                defaultValue={note}
                onChange={(e) => handleOnChange(e)}
              ></textarea>
            </div>
            <div className="form-group text-center">
              <button
                type="button"
                className={cx(
                  css`
                    background-color: #2196f3 !important;
                    padding: 14px 87px !important;
                    border-radius: 8px !important;
                    color: #ffffff !important;
                  `,
                  "btn btn-md font-12 font-bold"
                )}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading && (
                  <React.Fragment>
                    <CircularProgress size="1rem" />
                    <span className="ml-2">SUBMIT</span>
                  </React.Fragment>
                )}

                {!loading && "SUBMIT"}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalUpdate;
